const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/account/billing.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/account/billing")({
  beforeLoad: ({
    context
  }) => {
    if (!context.punditUser.current_community_member?.policies?.can_access_billing) {
      redirect({
        to: "/account",
        throw: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});